module.exports = __webpack_public_path__ + "img/upload_img_bg.1919022b.png";